import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { SuperComponent } from '../../super/super.component';

@Component({
  selector: 'app-approvel-vacation-request',
  templateUrl: './approvel-vacation-request.component.html',
  styleUrls: ['./approvel-vacation-request.component.scss']
})
export class ApprovelVacationRequestComponent extends SuperComponent implements OnInit {
  vacationRequests: any[] = [];
  isLoading: boolean = false;

  // Multi-select
  selectedRequests: any[] = [];

  // Popup
  showApprovalPopup: boolean = false;
  isSubmitting: boolean = false;

  approvalModel: any = {
    requestStatus: 3,
    refuseReason: ''
  };

  requestStatusList = [
    { id: 1, nameAr: 'قيد الانتظار', color: '#FFA500' },
    { id: 2, nameAr: 'مرفوض',        color: '#F44336' },
    { id: 3, nameAr: 'مقبول',        color: '#4CAF50' }
  ];

  constructor(
    gt: genericCustomStoreService,
    translate: TranslateService,
    Objects: ObjectsService
  ) {
    super(Objects, translate, gt);
  }

  ngOnInit(): void {
    this.loadVacationRequests();
  }

  loadVacationRequests() {
    this.isLoading = true;
    this.gt.GetVacationRequests().subscribe({
      next: (res: any[]) => {
        this.vacationRequests = res || [];
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading vacation requests:', err);
        this.isLoading = false;
        this.vacationRequests = [];
      }
    });
  }

  // ✅ عند تغيير الـ selection من الـ grid
  onSelectionChanged(e: any) {
    this.selectedRequests = e.selectedRowsData.filter(
      (r: any) => r.requestStatus === 1  // بس اللي status = قيد الانتظار
    );
  }

  // ✅ فتح الـ popup للـ multi-select
  openBulkApprovalPopup() {
    if (this.selectedRequests.length === 0) {
      alert('يرجى تحديد طلب واحد على الأقل في حالة "قيد الانتظار"');
      return;
    }

    this.approvalModel = {
      requestStatus: 3,
      refuseReason: ''
    };

    this.showApprovalPopup = true;
  }

  closeApprovalPopup() {
    this.showApprovalPopup = false;
    this.isSubmitting = false;
  }

  submitApproval() {
    if (this.isSubmitting) return;

    if (this.approvalModel.requestStatus === 2 && !this.approvalModel.refuseReason?.trim()) {
      alert('يجب إدخال سبب الرفض');
      return;
    }

    this.isSubmitting = true;

    // نبني الـ payload كـ array
    const dtoList = this.selectedRequests.map(request => ({
      id: request.id,
      requestStatus: this.approvalModel.requestStatus,
      aprovedStartDate: this.approvalModel.requestStatus !== 2
        ? this.formatDateForBackend(this.parseLocalDate(request.startDate))
        : null,
      aprovedEndDate: this.approvalModel.requestStatus !== 2
        ? this.formatDateForBackend(this.parseLocalDate(request.endDate))
        : null,
      refuseReason: this.approvalModel.requestStatus === 2
        ? this.approvalModel.refuseReason
        : null
    }));

    // ⚠️ غير اسم الـ API لو عندك endpoint خاص بالـ bulk
    this.gt.ApproveVacation(dtoList).subscribe({
      next: () => {
        this.isSubmitting = false;
        alert(`تم تنفيذ الإجراء بنجاح على ${this.selectedRequests.length} طلب`);
        this.selectedRequests = [];
        this.closeApprovalPopup();
        this.loadVacationRequests();
      },
      error: (err) => {
        this.isSubmitting = false;
        const msg = err?.error?.message || err?.error?.title || 'حدث خطأ ما';
        alert('خطأ: ' + msg);
        console.error('Bulk approval error:', err);
      }
    });
  }

  parseLocalDate(dateString: any): Date {
    if (!dateString) return new Date();
    const date = new Date(dateString);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  formatDateForBackend(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getStatusText(statusId: number): string {
    return this.requestStatusList.find(s => s.id === statusId)?.nameAr ?? 'غير معروف';
  }

  getStatusColor(statusId: number): string {
    return this.requestStatusList.find(s => s.id === statusId)?.color ?? '#999';
  }

  formatDate(date: any): string {
    if (!date || date === '0001-01-01T00:00:00') return '-';
    return new Date(date).toLocaleDateString('ar-EG');
  }
}